import React from 'react';
import { useParams } from 'react-router-dom';

import ChatContainer from './ChatContainer';

function Standalone(): JSX.Element {
  const { customerId } = useParams<{ customerId: string }>();

  return (
    <div className="chat-standalone-wrapper chat-standalone-inline" data-testid="outer-wrapper">
      <div className="chat-standalone-body" data-testid="body-wrapper">
        <ChatContainer customerId={customerId} openByDefault collapsible={false} />
      </div>
    </div>
  );
}

export default Standalone;
